export class BenefitFlag {
  public AmountUsed: number;
  public BenefitTypeId: number;
  public ProfileIds: number[];
  public QuantityUsed: number;
  // for flagging a single profile
  public ProfileId: number;
  public ProfileBenefitId: number;

  public constructor() {
    this.AmountUsed = 0;
    this.BenefitTypeId = 0;
    this.ProfileIds = [];
    this.QuantityUsed = 0;
    this.ProfileId = 0;
    this.ProfileBenefitId = 0;
  }
}
